// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"ae1e3441","703":"afaf9f20","787":"be725479"}[chunkId] + ".chunk.js";
};